"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./HeaderAdmin.css");
const react_router_dom_1 = require("react-router-dom");
const SidebarMobile_1 = __importDefault(require("../SidebarAdmin/SidebarMobile"));
const Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
require("../SidebarAdmin/SidebarAdmin.css");
const md_1 = require("react-icons/md");
const hook_1 = require("../../../../../redux/hook");
const Utils_1 = require("../../../../../utils/Utils");
const User_slice_1 = require("../../../../../redux/slice/User.slice");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const ServiceNotification_1 = require("../../../../../services/ServiceNotification/ServiceNotification");
// import { NotificationsStaff_RTK } from "../../../../../services/ServiceNotification/StaffServiceNotification";
const HeaderAdmin = () => {
    const { user, token } = (0, hook_1.useAppSelector)((state) => state.user);
    const location = (0, react_router_dom_1.useLocation)();
    const dispatch = (0, hook_1.useAppDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [data, setData] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    let showing = window.sessionStorage.getItem("showing");
    const onLogout = () => {
        dispatch((0, User_slice_1.onlogout)());
        react_hot_toast_1.default.success("Vous avez été déconnecté avec succès.", {
            duration: 3000,
            position: "top-center",
        });
        navigate("/", {
            replace: true,
        });
    };
    return (react_1.default.createElement("div", { className: "admin-header-component" },
        react_1.default.createElement("nav", { className: "empty-fluidy alling-header navbar navbar-expand-md navbar-dark fixed-top" },
            react_1.default.createElement("div", { className: "headering-admin" },
                react_1.default.createElement("div", { className: "container-logo-app-mobile no-view-desktop" },
                    react_1.default.createElement(react_router_dom_1.NavLink, { to: "/admin/dashboard", className: "no-link" },
                        react_1.default.createElement("img", { src: "/images/appImages/logo.png", alt: "Logo", className: "img-logo-app-mobile" }))),
                react_1.default.createElement("div", { className: "header-others-items" },
                    react_1.default.createElement("div", { className: "container-info-user-connect-header" },
                        react_1.default.createElement("div", { className: "container-menu-header-admin" },
                            react_1.default.createElement(ServiceNotification_1.NotificationsSOS_RTK, null)),
                        react_1.default.createElement("div", { className: "connected-user-container", id: "header-user-admin" },
                            react_1.default.createElement("div", { className: "connected-user-content ml-auto" },
                                react_1.default.createElement(Dropdown_1.default, null,
                                    react_1.default.createElement(Dropdown_1.default.Toggle, { id: "dropdown-basic", className: "dropdown-user-connect-admin" },
                                        react_1.default.createElement("div", { className: "user-acount-dashboard-header-display" },
                                            react_1.default.createElement("img", { src: (0, Utils_1.returnAvatarOrLogoImageSrcValue)(user === null || user === void 0 ? void 0 : user.avatar, (0, Utils_1.getName)(user)), alt: "Profil", className: "user-avatar" }),
                                            react_1.default.createElement("span", { className: "name-user-avatar" }, (0, Utils_1.getName)(user)),
                                            react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "8", height: "6", viewBox: "0 0 8 6", fill: "none" },
                                                react_1.default.createElement("path", { d: "M4.37305 4.81742L7.3501 1.84037C7.53174 1.65874 7.53174 1.36416 7.3501 1.18252C7.16843 1.00085 6.87392 1.00085 6.69225 1.18252L4.50929 3.36548C4.50929 3.36548 4.28963 3.61149 4.0459 3.60632C3.80803 3.60128 3.57896 3.36548 3.57896 3.36548L1.396 1.18259C1.21433 1.00092 0.919825 1.00092 0.73815 1.18259C0.647387 1.27339 0.601913 1.39248 0.601913 1.51152C0.601913 1.63057 0.647387 1.74961 0.73815 1.84045L3.7152 4.81742C3.89687 4.9991 4.19138 4.9991 4.37305 4.81742Z", fill: "#0C0B0B", stroke: "#0C0B0B", strokeWidth: "0.5" })))),
                                    react_1.default.createElement(Dropdown_1.default.Menu, { className: "container-dropdown-use-connect-admin-menu-item" },
                                        react_1.default.createElement(Dropdown_1.default.Item, { href: "#", className: "dropdown-item dropdown-item-admin", onClick: () => onLogout() },
                                            react_1.default.createElement("span", { className: "pe-2" },
                                                react_1.default.createElement(md_1.MdOutlineLogout, null)),
                                            react_1.default.createElement("span", null, "Logout")))))),
                        react_1.default.createElement("div", { className: "hiddenable-nav-mobile-container no-view-desktop" },
                            react_1.default.createElement("div", { className: "hiddenable-nav-mobile-content" },
                                react_1.default.createElement("div", { className: "container-nav-mobile" },
                                    react_1.default.createElement(SidebarMobile_1.default, null))))))))));
};
exports.default = HeaderAdmin;
